import { SocialPlatform, PerformerType } from '@app/modules/account-modules/performers.model';

export interface PlatformIconConfig {
  type: 'font' | 'svg';
  iconClass?: string;
  paths?: number;
  src?: string;
}

export const PERFORMER_TYPES = [
  { value: PerformerType.Band, name: 'Группа' },
  { value: PerformerType.Solo, name: 'Соло-исполнитель' },
  { value: PerformerType.Cover, name: 'Кавер-группа' },
  { value: PerformerType.Acoustic, name: 'Акустическое выступление' },
  { value: PerformerType.Singer, name: 'Вокалист' },
  { value: PerformerType.Dj, name: 'Диджей' },
  { value: PerformerType.Instrumentalist, name: 'Инструменталист' },
  { value: PerformerType.Performance, name: 'Перформанс' }
];

export const SOCIAL_PLATFORMS = [
  { value: SocialPlatform.Instagram, name: 'Instagram' },
  { value: SocialPlatform.YouTube, name: 'YouTube' },
  { value: SocialPlatform.VK, name: 'ВКонтакте' },
  { value: SocialPlatform.SoundCloud, name: 'SoundCloud' },
  { value: SocialPlatform.Spotify, name: 'Spotify' },
  { value: SocialPlatform.AppleMusic, name: 'Apple Music' },
  { value: SocialPlatform.TikTok, name: 'TikTok' },
  { value: SocialPlatform.Website, name: 'Личный сайт' },
  { value: SocialPlatform.YandexMusic, name: 'Яндекс Музыка' },
  { value: SocialPlatform.Telegram, name: 'Telegram' }
];

export const PLATFORM_ICON_MAP: Record<number, PlatformIconConfig> = {
  [SocialPlatform.Instagram]: { type: 'font', iconClass: 'mr-icon mr-icon-inst-color', paths: 4 },
  [SocialPlatform.YouTube]: { type: 'font', iconClass: 'mr-icon mr-icon-yt-color', paths: 2 },
  [SocialPlatform.VK]: { type: 'font', iconClass: 'mr-icon mr-icon-vk-color', paths: 2 },
  [SocialPlatform.SoundCloud]: { type: 'svg', src: 'assets/images/icons/soundcloud.svg' },
  [SocialPlatform.Spotify]: { type: 'svg', src: 'assets/images/icons/spotify.svg' },
  [SocialPlatform.AppleMusic]: { type: 'svg', src: 'assets/images/icons/apple-music.svg' },
  [SocialPlatform.TikTok]: { type: 'svg', src: 'assets/images/icons/tiktok.svg' },
  [SocialPlatform.Website]: { type: 'svg', src: 'assets/images/icons/website.svg' },
  [SocialPlatform.YandexMusic]: { type: 'font', iconClass: 'mr-icon mr-icon-ya-color', paths: 2 },
  [SocialPlatform.Telegram]: { type: 'font', iconClass: 'mr-icon mr-icon-telegram-color', paths: 2 }
};
